angular.module('AppCtrl.config', [
    'jv.Common.Directives.Datepicker',
    'jv.Common.Directives.Timepicker',
    'ngRoute',
    'jv.source.modal-adapter.service'
])
.constant('CustomLinkTypes', ['TALENTPOOLWIDGET', 'REQUISITION', 'CUSTOMLINK'])
.constant('RoutingConstants', [{
    //email
    baseUrl: '/campaign/email',
    actions: [{
        actionName: '/summary/:ceid',
        routingValue: {
            templateUrl: 'campaign2/summary.html',
            controller: 'CampaignDetailsCtrl'
        },
        tabInfo: {
            order: 1,
            content: 'JV_CAMPAIGNS_CONSTANTS_ROUTINGCONSTANTS_SUMMARY'
        }
    }, {
        actionName: '/details/:ceid',
        routingValue: {
            templateUrl: 'campaign2/details.html',
            controller: 'CampaignDetailsTabController'
        },
        tabInfo: {
            order: 2,
            content: 'JV_CAMPAIGNS_CONSTANTS_ROUTINGCONSTANTS_DETAILS'
        }
    }, {
        actionName: '/editDetails/:ceid',
        routingValue: {
            templateUrl: window.jvUrls.source + '/campaign2/addCampaignSnippet.html',
            controller: 'AddCampaignCtrl'
        }
    }, {
        actionName: '/addContacts/:ceid',
        routingValue: {
            templateUrl: 'campaign2/addContacts.html',
            controller: 'AddContactsController'
        },
        tabInfo: {
            order: 3,
            content: 'JV_CAMPAIGNS_CONSTANTS_ROUTINGCONSTANTS_ADD_CONTACTS'
        }
    }, {
        actionName: '/campaigncontact/:ceid',
        routingValue: {
            templateUrl: 'campaign2/campaignContacts.html',
            controller: 'EmailCampaignContactListCtrl',
            resolve: {
                'urlResolution': function () {
                    return 'campaign2/campaignContactList.html';
                }
            }
        },
        tabInfo: {
            order: 4,
            content: 'JV_CAMPAIGNS_CONSTANTS_ROUTINGCONSTANTS_CAMPAIGN_CONTACTS'
        }
    }, {
        actionName: '/email/:ceid',
        routingValue: {
            templateUrl: 'campaign2/emailContents.html',
            controller: 'EmailsController'
        },
        tabInfo: {
            order: 5,
            content: 'JV_CAMPAIGNS_CONSTANTS_ROUTINGCONSTANTS_EMAIL_CONTENT'
        }
    }, {
        actionName: '/richEmail/:ceid',
        routingValue: {
            templateUrl: 'campaign2/richEmail.html',
            controller: 'EmailsTemplateController'
        }
    }, {
        //VA: For edit the messages, meid: messageid
        actionName: '/richEmail/:ceid/:meid',
        routingValue: {
            templateUrl: 'campaign2/richEmail.html',
            controller: 'EmailsTemplateController'
        }
    }]
}, {
    //webpage
    baseUrl: '/campaign/webpage',
    actions: [{
        actionName: '/summary/:ceid',
        routingValue: {
            templateUrl: 'campaign2/webpage/summary.html',
            controller: 'CampaignSummaryListCtrl'
        },
        tabInfo: {
            order: 1,
            content: 'JV_CAMPAIGNS_CONSTANTS_ROUTINGCONSTANTS_SUMMARY'
        }
    }, {
        actionName: '/details/:ceid',
        routingValue: {
            templateUrl: 'campaign2/details.html',
            controller: 'CampaignDetailsTabController'
        },
        tabInfo: {
            order: 2,
            content: 'JV_CAMPAIGNS_CONSTANTS_ROUTINGCONSTANTS_DETAILS'
        }
    }, {
        actionName: '/editDetails/:ceid',
        routingValue: {
            templateUrl: window.jvUrls.source + '/campaign2/addCampaignSnippet.html',
            controller: 'AddCampaignCtrl'
        }
    }, {
        actionName: '/content/:ceid',
        routingValue: {
            templateUrl: 'campaign2/webpage/content.html',
            controller: 'WebpageContentCtrl'
        },
        tabInfo: {
            order: 3,
            content: 'JV_CAMPAIGNS_CONSTANTS_ROUTINGCONSTANTS_WEB_PAGE'
        }
    }]
}, {
    //social media
    baseUrl: '/campaign/social',
    actions: [{
        actionName: '/summary/:ceid',
        routingValue: {
            templateUrl: 'campaign2/social/summary.html',
            controller: 'SocialSummaryCtrl'
        },
        tabInfo: {
            order: 1,
            content: 'JV_CAMPAIGNS_CONSTANTS_ROUTINGCONSTANTS_SUMMARY'
        }
    }, {
        actionName: '/details/:ceid',
        routingValue: {
            templateUrl: 'campaign2/details.html',
            controller: 'CampaignDetailsTabController'
        },
        tabInfo: {
            order: 2,
            content: 'JV_CAMPAIGNS_CONSTANTS_ROUTINGCONSTANTS_DETAILS'
        }
    }, {
        actionName: '/editDetails/:ceid',
        routingValue: {
            templateUrl: window.jvUrls.source + '/campaign2/addCampaignSnippet.html',
            controller: 'AddCampaignCtrl'
        }
    }, {
        actionName: '/accounts/:ceid',
        routingValue: {
            templateUrl: 'campaign2/social/accounts.html',
            controller: 'SocialAccountsCtrl'
        },
        tabInfo: {
            order: 3,
            content: 'JV_CAMPAIGNS_CONSTANTS_ROUTINGCONSTANTS_ACCOUNTS'
        }
    }, {
        actionName: '/Messages/:ceid',
        routingValue: {
            templateUrl: 'campaign2/social/messages.html',
            controller: 'SocialMessagesCtrl'
        },
        tabInfo: {
            order: 4,
            content: 'JV_CAMPAIGNS_CONSTANTS_ROUTINGCONSTANTS_MESSAGES'
        }
    }, {
        actionName: '/editMessage/:ceid',
        routingValue: {
            templateUrl: 'campaign2/social/richMessage.html',
            controller: 'MessagesTemplateController',
            resolve: {
                'loadType': function () {
                    return 'NEW';
                }
            }
        }
    }, {
        //For edit message templates, meid: messageid
        actionName: '/editMessage/:ceid/:meid/edit',
        routingValue: {
            templateUrl: 'campaign2/social/richMessage.html',
            controller: 'MessagesTemplateController',
            resolve: {
                'loadType': function () {
                    return 'EDIT';
                }
            }
        }
    }, {
        //For edit message templates, meid: messageid
        actionName: '/editMessage/:ceid/:meid/copy',
        routingValue: {
            templateUrl: 'campaign2/social/richMessage.html',
            controller: 'MessagesTemplateController',
            resolve: {
                'loadType': function () {
                    return 'COPY';
                }
            }
        }
    }]
}])
.config(['$routeProvider', 'RoutingConstants', '$locationProvider', function ($routeProvider, RoutingConstants, $locationProvider) {

    angular.forEach(RoutingConstants, function (campaignType) {
        angular.forEach(campaignType.actions, function (campaignAction) {
            $routeProvider.when(campaignType.baseUrl + campaignAction.actionName, campaignAction.routingValue);
        });
    });

    $routeProvider
    .otherwise({
        redirectTo: '/campaign/email/summary/'
    });
    $locationProvider.hashPrefix('');
}]);

angular.module('AppCtrl.service', ['AddAppCtrl', 'jv.FacebookService'])
.value('fbPermissions', ['manage_pages'])
.factory('CampaignsFBFactory', ['campaignService', 'jvFacebookService', 'fbPermissions', function (campaignService, jvFacebookService, fbPermissions) {
    return function (successCallback) {
        campaignService.getFBAccounts({}, successCallback, function () {
            jvFacebookService.login(fbPermissions, function (err, session) {
                if (err) {
                    return;
                }
                campaignService.sendAccessToken({
                    accessToken: session.authResponse.accessToken
                }, successCallback);
            });
        });
    };
}])
.factory('CampaignsReauthorizeFactory', ['campaignService', 'jvFacebookService', 'fbPermissions', function (campaignService, jvFacebookService, fbPermissions) {
    return function (errorEId, successCallback) {
        jvFacebookService.authorize(fbPermissions, function (err, session) {
            if (err) {
                return;
            }
            campaignService.sendAccessToken({
                accessToken: session.authResponse.accessToken,
                errorEId: errorEId
            }, successCallback);
        });
    };
}])
.factory('CampaignsTwitterFactory', ['Twitter', function (Twitter) {
    return function (ceid, successCallback) {
        Twitter.connect('/TalentNetwork/action/crm/campaign/twitter/' + ceid + '/connect', successCallback);
    };
}])
.factory('tabInfoService', function ($location, $routeParams, $rootScope, RoutingConstants) {

    var returnObj = {
        tabs: []
    };
    return function () {

        var loop = 0,
            RoutingConstantsLength = RoutingConstants.length,
            locationHash = $location.path(),
            tabInfoArray = [],
            ceid;

        for (; loop < RoutingConstantsLength; loop++) {
            if (locationHash.indexOf(RoutingConstants[loop].baseUrl) === 0) {
                break;
            }
        }

        if (loop === RoutingConstantsLength) {
            throw new Error('Expected hash string not coming up!');
        }
        angular.forEach(RoutingConstants[loop].actions, function (campaignActions) {
            if (campaignActions.tabInfo) {
                var _tmpTabInfo = angular.copy(campaignActions.tabInfo);
                _tmpTabInfo = angular.extend(_tmpTabInfo, {
                    link: window.jvUrls.source + '/campaign2/campaignDetails.html#' + RoutingConstants[loop].baseUrl + campaignActions.actionName.replace(':ceid', $routeParams.ceid)
                });
                // represent the selected tab differently.
                if (_tmpTabInfo.link.indexOf($location.path()) !== -1) {
                    _tmpTabInfo.active = 'active';
                }
                tabInfoArray.push(_tmpTabInfo);
            }
        });
        returnObj.tabs = tabInfoArray.sort(function (a, b) {
            return a.order > b.order;
        });
        return returnObj;
    };
});
angular.module('AppCtrl', [
    'AddAppCtrl',
    'AppCtrl.service',
    'AppCtrl.config',
    'AppCtrl.jobvite.directive',
    'AppCtrl.tinymce.directive',
    'AppCtrl.modals',
    'jv.Common.Modal',
    'AppCtrl.campaign.constant',
    'AppCtrl.campaign.webpage.grid',
    'JV.FB.Service',
    'JV.Core.Directives',
    'jv.Common.Directives.Formtemplate',
    'ui.directives',
    'jv.Common.Directives.LoadingButton',
    'jv.Common.i18n',
    'jv.Common.Filters',
    'jv.Common.Directives.HideOnBlur',
    'jv.iframe-preview.directive',
    'jv.common.root-modal.directive',
    'MessagesTemplateController',
    'SocialMessagesCtrl'
])
    .filter('lowercase', function () {
        return function (string) {
            var length = string.length;
            var firstChar = string.charAt(0);
            var rest = string.substr(1, length).toLowerCase();
            return firstChar.concat(rest);
        };
    })

    // copy/paste from jv.directives (including creates error)
    // for multiple location tooltips in FormTemplate directive
    .factory('isIE', ['$window', function ($window) {
        if ($window.addEventListener) {
            return false;
        }
        return true;
    }])
    .factory('addEventListener', ['isIE', function (isIE) {
        var _toAttach = angular.noop,
            _prefix = angular.identity;
        if (!isIE) {
            _toAttach = 'addEventListener';
            _prefix = angular.identity;
        } else {
            _toAttach = 'attachEvent';
            _prefix = function (val) {
                return 'on' + val;
            };
        }

        var _attach = function (val, cb, capture) {
            this[_toAttach](_prefix(val), cb, capture || false);
        };

        return function (el) {
            return angular.bind(el, _attach);
        };
    }])
    /// TODO (MikeMac): Refactor this to DRY.
    .factory('removeEventListener', ['isIE', function (isIE) {
        var _toAttach = angular.noop,
            _prefix = angular.identity;
        if (!isIE) {
            _toAttach = 'removeEventListener';
            _prefix = angular.identity;
        } else {
            _toAttach = 'detachEvent';
            _prefix = function (val) {
                return 'on' + val;
            };
        }

        var _attach = function (val, cb, capture) {
            this[_toAttach](_prefix(val), cb, capture || false);
        };

        return function (el) {
            return angular.bind(el, _attach);
        };
    }])
    .factory('bindAndUnbindClickToDocument', ['$document', 'addEventListener', 'removeEventListener', function ($document, addEvent, removeEvent) {
        return function bindAndUnbindClickToDocument(el, action) {
            var _doc = $document[0];
            var _outsideHandler = function (ev) {
                action();
                removeEvent(_doc)('click', _outsideHandler, true);
            };
            addEvent(_doc)('click', _outsideHandler, true);
        };
    }])
    .factory('stopPropagation', ['isIE', function (isIE) {
        if (isIE) {
            return function (event) {
                event.cancelBubble = true;
            };
        } else {
            return function (event) {
                event.stopPropagation();
                event.stopImmediatePropagation();
            };
        }
    }])
    .factory('addClick', ['bindAndUnbindClickToDocument', 'addEventListener', 'stopPropagation', function (docMagic, addEvent, stopPropagation) {
        return function addClick(el, activate, deactivate) {
            addEvent(el[0])('click', function (ev) {
                docMagic(el, deactivate);
                activate();
                // stopPropagation(ev);
            }, true);
        };
    }])
    .factory('addMouseover', function () {
        return function addMouseover(el, activate, deactivate) {
            el.bind('mouseover', function () {
                activate();
            });
            el.bind('mouseout', function () {
                deactivate();
            });
        };
    })
    // Renders the "Disable CAPTCHA for __ hours" dropdown as a Select2, without the searchbox
    .directive('jvSelect2CampaignNoSearch', ['Select2Constants', 'returnObjectFromTextAndArray', '$timeout', function(Select2, $timeout) {
      return {
        restrict: 'A',
        require: ['?ngModel'],
        link: function (scope, element, attr, requires) {
          var ngModel = requires[0];
          var options = angular.copy(window._jvPluginDefaults.select2);
          options.minimumResultsForSearch = -1;
          options.placeholder = "4";
          element.select2(options);
        }
      }
    }])
    //TODO: Remove this after name conflict is removed for jvSelect2. Right now two are available
    .directive('jvSelect2Campaign', ['Select2Constants', 'returnObjectFromTextAndArray', '$timeout', function (Select2, searchFromText, $timeout) {
        return {
            restrict: 'A',
            require: ['ngModel', '?jvSelect2Ids', '?jvSelect2Objects'],
            link: function (scope, element, attr, requires) {
                var ngModel = requires[0];
                var baseCtrl = requires[1] || requires[2];
                var sharedModel = !!attr.jvSelect2SharedModel || false;
                /*  attr.jvSelect2CanClear
                        This attribute is used to clear all options form the select2 dropdown. By default its set to false 
                        meaning when user hits 'x' on a non-ajax select2 it defaults back to the last selected value.
                        If on clicking 'x' you want to default back to the text 'Select an option' set an attribute
                        jv-select2-can-clear='true' in the select2 declartion. NV */
                var canClearOptions = false;
                if (attr.jvSelect2CanClear === 'true') {
                    canClearOptions = true;
                }
                // modified condition, as it was passing for requires[1] = null, after update to angular JS 1.7.8, now it check for null, undefined and empty object
                if (angular.isUndefined(baseCtrl) || (!requires[1] && !requires[2])) {
                    throw new SyntaxError('You must define either jv-Select2-Ids OR jv-Select2-Objects, not both and not neither');
                }
                var hiddenField = angular.element("<input style='" + attr["style"] + "' type=\"hidden\" id=\"" + attr.jvSelect2 + "\" />"),
                    _text = baseCtrl._text,
                    _id = baseCtrl._id,
                    getId = function (obj) {
                        return obj[_id];
                    },
                    getData = function (obj) {
                        var paths = _text.split('.'),
                            current = obj,
                            i;

                        for (i = 0; i < paths.length; ++i) {
                            if (current[paths[i]] === undefined) {
                                return undefined;
                            } else {
                                current = current[paths[i]];
                            }
                        }
                        return current;
                    };

                element.append(hiddenField);

                ngModel.$render = function () {
                    $(hiddenField).select2('data', ngModel.$viewValue);
                    if (ngModel.$viewValue === baseCtrl._placeholder) {
                        ngModel.$setViewValue(baseCtrl._placeholder);
                    }
                };

                var options = window._jvPluginDefaults ? angular.copy(window._jvPluginDefaults.select2) : {};

                function ifDefinedThenOptionize(hash, value) {
                    if (angular.isDefined(value)) {
                        options[hash] = value;
                    }
                }
                ifDefinedThenOptionize('placeholder', attr[Select2.Placeholder]);
                ifDefinedThenOptionize('allowClear', attr[Select2.AllowClear] !== 'false'); //property has to be set as boolean than string
                ifDefinedThenOptionize('formatSelection', getData);
                ifDefinedThenOptionize('formatResult', getData);
                ifDefinedThenOptionize('id', getId);
                ifDefinedThenOptionize('data', {
                    results: baseCtrl._dataSource,
                    text: _text
                });
                //@i18N: extend Select2 configuration to support group {Parent-child}  rendering
                if (attr.jvSelect2TemplateGroup) {
                    angular.extend(options, scope.select2Options);
                }
                options.initSelection = function (elem, callback) {
                    var x = {};
                    x[_text] = ngModel.$viewValue[_text];
                    callback(x);
                };

                $(hiddenField).select2(options).on('change', function (e) {
                    if (!scope.$$phase) {
                        scope.$apply(function () {
                            var obj;
                            if (e.target.value) {
                                obj = searchFromText(e.target.value, _id, baseCtrl._dataSource, baseCtrl._placeholder);
                            } else if (canClearOptions) {
                                e.target.value = i18n['SELECT_AN_OPTION'] || 'Select an option';
                                baseCtrl._placeholder = {
                                    'label': i18n['SELECT_AN_OPTION'] || 'Select an option'
                                };
                                obj = searchFromText(e.target.value, _id, baseCtrl._dataSource, baseCtrl._placeholder);
                                $(hiddenField).select2('data', {
                                    name: i18n['SELECT_AN_OPTION'] || 'Select an option',
                                    label: i18n['SELECT_AN_OPTION'] || 'Select an option'
                                });
                            }
                            ngModel.$setViewValue(obj);
                        });
                    }
                });

                // Watch the data object, and update the directive if it has changed
                //VA: Updated, beause of below code the drop down were removing the placeholder for the select2, now first checking for the value being defined and then making the change.
                if (sharedModel) {
                    scope.$watch(attr.jvSelect2Data, function (newVal, oldVal) {
                        if (angular.isDefined(newVal)) {
                            $(hiddenField).select2(angular.extend({
                                data: {
                                    results: newVal
                                }
                            }, window._jvPluginDefaults.select2));
                        }
                    });
                }

                scope.$watch(attr[Select2.Disable], function (newValue, oldValue) {
                    if (newValue === true) {
                        $(hiddenField).select2('enable', false);
                    } else {
                        $(hiddenField).select2('enable', true);
                    }
                });
            }
        };
    }])
    .directive('tooltip', ['$compile', 'addClick', 'addMouseover', 'bindAndUnbindClickToDocument', function ($compile, addClick, addMouseover, docMagic) {
        return {
            replace: true,
            scope: true,
            compile: function (tEl, tAttr) {
                var _trigger = tEl.find('[tooltip-trigger]'),
                    trigger = _trigger.html(),
                    _title = tEl.find('[tooltip-title]'),
                    _title_exists = (_title.length > 0),
                    title = _title.html(),
                    _body = tEl.find('[tooltip-body]'),
                    body = _body.html();
                _trigger.remove();
                _title.remove();
                _body.remove();
                return {
                    pre: function (scope, el, attr) {
                        function tooltipAppear() {
                            scope.__showTooltip__ = true;
                        }

                        function tooltipDisappear() {
                            scope.__showTooltip__ = false;
                        }

                        function tooltipAppearWithApply() {
                            scope.$apply(tooltipAppear);
                        }

                        function tooltipDisappearWithApply() {
                            scope.$apply(tooltipDisappear);
                        }

                        var triggerHtml = angular.element(trigger),
                            tooltip = angular.element("<div class=\"tooltipWindow\" ng-show=\"__showTooltip__\"" + (attr.ngAnimate ? ' ng-animate=\"' + attr.ngAnimate + '\"' : '') + '></div>'),
                            tooltipContainer = angular.element("<div class=\"tooltipContainer\"></div>"),
                            titleEl = angular.element("<div class=\"title\">" + title + '</div>'),
                            bodyEl = angular.element("<div class=\"body\">" + body + '</div>');
                        setEvents = ((angular.isDefined(attr.$attr.showonhover) && attr.$attr.showonhover !== 'false') ? addMouseover : addClick);


                        if (angular.isDefined(attr.show)) {
                            scope.$watch(attr.show, function (newVal) {
                                if (newVal) {
                                    docMagic(el, function () {
                                        scope.$parent[attr.show] = false;
                                        tooltipDisappearWithApply();
                                    });
                                    tooltipAppear();
                                }
                            });
                        }

                        scope.__showTooltip__ = false;
                        el.append($compile(triggerHtml)(scope));
                        if (_title_exists) {
                            tooltipContainer.append(titleEl);
                        }
                        tooltipContainer.append(bodyEl);
                        tooltip.append(tooltipContainer);

                        el.append($compile(tooltip)(scope));
                        el.removeClass('tooltip');

                        setEvents(el, tooltipAppearWithApply, tooltipDisappearWithApply);
                    },
                    post: angular.noop
                };
            }
        };
    }]);
// controller('MessagesTemplateController', MessagesTemplateController);
/*************************************************************/
/******************** Controllers ****************************/
/*************************************************************/
/**
 * Main controller that fills the common portion for all the tabs.
 * @param {Object} $scope
 * @param {Object} campaignService
 * @param {Object} $location
 */
var appCtrlModule = angular.module('AppCtrl');
appCtrlModule.controller('CampaignDetailsCtrl', ['$scope', 'campaignService', '$routeParams', 'tabInfoService',
    function ($scope, campaignService, $routeParams, tabInfoService) {

        // Needed for placing proper urls for clicking through the tabs.
        $scope.campaignEId = $routeParams.ceid;
        // For Campaign details
        $scope.campaign = {};
        // For Campaign analytics
        $scope.campaignAnalytics = {};
        $scope.getStarted = {};
        $scope.getStarted.firstLoad = true;
        $scope.getStarted.explode = true;
        $scope.results = {};
        $scope.results.list = null;
        $scope.contactsAvailable = false;

        campaignService.getCampaignContacts({}, function (results) {
            if (results.resultCount > 0) {
                $scope.contactsAvailable = true;
            }
        });

        $scope.$on('campaignDetailsResults', function (event, results) {
            $scope.campaign = results.bean;
        });
        $scope.$on('campaignSummaryResults', function (event, results) {
            $scope.analytics = results;
            $scope.atsEnabled = results.atsEnabled;
            if ($scope.atsEnabled === false) {
                $scope.adjustWidth = 'jv-adjustWidth';
                $scope.adjustTitleWidth = 'jv-adjustTitleWidth';
            }
        });


        // type: MESSAGE, REQUISITION.
        // key: campaignMessageAnalytics, requisitions
        // entityKeyId: messageId, id
        function getObjectWithId(type, key, entityKeyId, results, id) {
            var obj = results[key];
            for (var i = 0, j = obj.length; i < j; i++) {
                var entityObj = obj[i];
                if (entityObj[entityKeyId] === id) {
                    return entityObj;
                }
            }
        }

        function prepareMessageData(results) {
            var _message = [];
            angular.forEach(results.messages, function (messageObj) {
                var _tempMessage = messageObj;
                // add properties.
                //          _tempMessage.anlytics = results.campaignMessageAnalytics[ messageObj.id ];
                //          _tempMessage.req = results.requisitions[ messageObj.id ];
                _tempMessage.anlytics = getObjectWithId('MESSAGE', 'campaignMessageAnalytics', 'messageId', results, messageObj.id);
                _tempMessage.req = getObjectWithId('MESSAGE', 'requisitions', 'id', results, messageObj.jobEId);
                _message.push(_tempMessage);

            });
            return _message;
        }

        campaignService.getDetails();
        campaignService.getSummary();
        campaignService.getMessageSummary(null, function (results) {
            $scope.results.list = prepareMessageData(results);
            $scope.getStarted.firstLoad = ($scope.results.list.length > 0 ? false : $scope.getStarted.firstLoad);
            $scope.getStarted.explode = ($scope.results.list.length > 0 ? false : $scope.getStarted.explode);
        });

        $scope.getMessageLinks = function (index) {
            if ($scope.results.list[index].links !== undefined) {
                return;
            }
            campaignService.getMessageLinkSummary({
                'messageId': $scope.results.list[index].id
            }, function (results) {
                $scope.results.list[index].links = results;
            });
        };
        tabInfoService();
    }
]);

/**
 * Controller for the details tab.
 * @param {Object} $scope
 * @param {Object} campaignService
 * @param {Object} $location
 */
appCtrlModule.controller('CampaignDetailsTabController', ['$scope', 'campaignService', '$routeParams', 'tabInfoService', '$location',
    function ($scope, campaignService, $routeParams, tabInfoService, $location) {
        $scope.$on('campaignDetailsResults', function (event, results) {
            $scope.results = results;
        });
        var _url = $location.url();
        //var _url = '/campaign/email/details/X45'
        for (var i = 0; i < 2; i++) {
            var _index = _url.lastIndexOf('/');
            _url = _url.substring(_index, 0);
        }
        _url += '/editDetails/';
        // change the url to the edit mode.
        $scope.editLink = window.jvUrls.source + '/campaign2/campaignDetails.html#' + _url + $routeParams.ceid;
        $scope.campaign = {};
        campaignService.getDetails();
        tabInfoService();
    }
]);

/**
 * Controller for the add contacts. Its an iframe so we dont need to have a special file separately for it.
 * @param {Object} $scope
 */
appCtrlModule.controller('AddContactsController', ['$scope', 'tabInfoService', 'campaignService', '$routeParams',
    function ($scope, tabInfoService, campaignService, $routeParams) {
        $scope.iframeSrc = window.jvUrls.source + '/person/contacts.html?noHeader=true&type=campaigns&campaigneid=' + $routeParams['ceid'] + '&ck=false';
        //Need to add page loading image
        //HACK: necessary to make it as part of the window object so that it can resize the height of the contacts tab.
        window.adjustContactsHeight = function (height) {
            $('.jv-contactsBody').css({
                'height': height + 'px',
                'min-height': '900px'
            });
        };

        $scope.campaign = {};
        $scope.$on('campaignDetailsResults', function (event, results) {
            $scope.campaign = results.bean;
        });
        campaignService.getDetails();
        tabInfoService();
    }
]);

appCtrlModule.controller('EmailCampaignContactListCtrl', ['$scope', 'tabInfoService', 'urlResolution', 'campaignService',
    function ($scope, tabInfoService, urlResolution, campaignService) {
        $scope.url = urlResolution;
        $scope.campaign = {};
        $scope.$on('campaignDetailsResults', function (event, results) {
            $scope.campaign = results.bean;
        });
        campaignService.getDetails();
        tabInfoService();
    }
]);

appCtrlModule.controller('WebpageDetailsCtrl', ['$scope', 'tabInfoService', 'campaignService',
    function ($scope, tabInfoService, campaignService) {
        $scope.campaign = {};
        $scope.$on('campaignDetailsResults', function (event, results) {
            $scope.campaign = results.bean;
            if (results.webpageUrl) {
                $scope.campaign.webpageUrl = results.webpageUrl;
            }
        });
        campaignService.getDetails();
        tabInfoService();
    }
]);

appCtrlModule.controller('WebpageContentCtrl', ['$scope', 'tabInfoService', 'campaignService', 'Draggable', 'CustomLinkTypes', 'modalService', '$q', 'draggableTemplate', 'joinUsDraggableTemplate', '$window', '3SecondNotificationBar', 'TinyMceMessageToContent', 'ContentToTinyMceMessage', '$templateCache', '$interpolate',
    function ($scope, tabInfoService, campaignService, Draggable, CustomLinkTypes, modalService, $q, draggableTemplate, joinUsDraggableTemplate, $window, NBar, TinyMceMessageToContent, ContentToTinyMceMessage, $templateCache, $interpolate) {
        $scope.showAddRequisition = true;
        $scope.showAddLink = true;
        $scope.campaign = {};
        $scope.content = {
            htmlMessage: ''
        };
        $scope.editMode = true;
        $scope.metadata = {};
        $scope.links = {};
        $scope.links.custom = [];
        $scope.links.requisition = [];
        $scope.links.reqIds = [];
        $scope.links.talentpool = [];
        $scope.links.templates = [];
        $scope.savingContent = false;
        $scope.captchaEnabled = true;
        $scope.disableCaptchaOption = true;
        $scope.captchaDisplayMode = false;
        $scope.allTimezones = [];
        $scope.timeZoneSelected = null;
        $scope.datePickerOptions = {};
        $scope.datePickerOptions.saveFormat = 'mm/dd/yy';
        $scope.datePickerOptions.minDate = campaignService.getTodayDateUserTimezone(window._jvselfUser.locale.timezone);
        $scope.newWebCampaignValidationEnabled = newWebCampaignValidationEnabled;

        $scope.dialogs = {};
        $scope.dialogs.draggableLinks = false;

        var linkCounter = 1;

        $scope.$watch('timeZoneSelected', function (newValue, oldValue, scope) {
            if (newValue) {
                $scope.datePickerOptions.minDate = campaignService.getTodayDateUserTimezone(newValue);
            }
        });


        $scope.addCustomLink = function (link) {

            var deferredObj = editLinkMetadata(link);
            // collect metadata from user.  Use addAnyLink as a callback.
            deferredObj.then(function (successVal) {
                var newContent = '[{0}]'.format(successVal.actionName);
                var metadata = {
                    actionName: successVal.actionName,
                    actionUrl: successVal.actionUrl
                };
                var newLink = Draggable(successVal.actionName, newContent, draggableTemplate, metadata);
                if (link) {
                    $scope.content.htmlMessage = $scope.content.htmlMessage.split(link.metadata.templateVariable).join(newLink.metadata.templateVariable);
                    angular.extend(link, newLink);
                } else {
                    $scope.links.custom.push(newLink);
                }
            });
        };

        $scope.addRequisition = function (link) {
            campaignService.getRequisitionFilters({}, function (results) {
                var deferredService = $q.defer();
                modalService.selectRequisition(results, deferredService);
                deferredService.promise.then(function (successVal) {
                    if ($scope.links.reqIds && $scope.links.reqIds.length > 0 && $.inArray(successVal.EId, $scope.links.reqIds) !== -1) {
                        //The requisition link token already exists for the campaign.
                    } else {
                        var metadata = {
                            jobEId: successVal.EId
                        };
                        metadata.jobTitle = successVal.title;
                        if (successVal.requisitionId) {
                            metadata.requisitionId = successVal.requisitionId.trim();
                        }
                        var reqTitleText = campaignService.getReqTitleText(successVal.title, successVal.requisitionId);
                        var newLink = Draggable(reqTitleText, '[' + reqTitleText + ']', draggableTemplate, metadata);
                        //link is defined when we are trying to edit a requisition link rather than adding a new requisition
                        if (link) {
                            if ($scope.links.reqIds && $scope.links.reqIds.indexOf(link.metadata.jobEId) !== -1) {
                                //When editing a requisition, we have to make sure that  $scope.links.reqIds has the updated list of reqIds 
                                $scope.links.reqIds.splice($scope.links.reqIds.indexOf(link.metadata.jobEId), 1);
                            }
                            angular.extend(link, newLink);
                            //Adding the new edited requisitions jobEId to $scope.links.reqIds
                            $scope.links.reqIds.push(newLink.metadata.jobEId);
                        } else {
                            $scope.links.requisition.push(newLink);
                            $scope.links.reqIds.push(successVal.EId);
                            $scope.showAddRequisition = false;
                        }
                    }
                });
            });
        };

        $scope.addJoinUsApp = function (link) {
            var thisLink = link;
            var deferredObj = editTalentPoolWidgetMetadata(thisLink);
            deferredObj.then(function (successVal) {
                if (thisLink) {
                    angular.extend(thisLink.metadata, successVal);
                } else {
                    thisLink = Draggable('Join Us App', '[Join-Us-App]', joinUsDraggableTemplate, successVal);
                    $scope.links.talentpool.push(thisLink);
                }
            });
        };

        $scope.links.templates.push(Draggable('Company Name', '[company-name]', draggableTemplate, {}));
        $scope.links.templates.push(Draggable('Company Logo', '[company-logo]', draggableTemplate, {}));

        var editLinkMetadata = function (link) {
            var resultData = {};
            if (angular.isDefined(link)) {
                resultData = {
                    metadata: {
                        actionName: link.text,
                        actionUrl: link.metadata.actionUrl
                    }
                };
            }
            if ($scope.links && $scope.links.custom) {
                resultData.customTemplates = $scope.links.custom;
            }
            if (link && link.text) {
                resultData.currentLinkText = link.text;
            }
            var deferred = $q.defer();
            modalService.getLinkDetails(resultData, deferred);
            return deferred.promise;
        };

        var editRequisitionMetadata = function (link) {
            var resultData = link || {};
            var deferred = $q.defer();
            // open edit box for requisitions
            modalService.selectRequisition(resultData, deferred);
            return deferred.promise;
        };

        var editTalentPoolWidgetMetadata = function (link) {
            // open edit box for talent pool widget
            var deferredObj = $q.defer();
            var resultData = {};
            if (angular.isDefined(link)) {
                angular.extend(resultData, link.metadata);
            }

            modalService.configureWidget(resultData, deferredObj);

            return deferredObj.promise;
        };

        $scope.$on('campaignDetailsResults', function (event, results) {
            $scope.campaign = results.bean;
        });
        $scope.PreviewWebPage = function () {
            $scope.saveContent(true);
        };

        $scope.buildAllLinks = function() {
          var metadata = angular.extend({actions: []}, $scope.metadata);
          var allLinks = [];
          angular.forEach($scope.links.custom, function (link) {
              allLinks.push(link);
              metadata.actions.push({
                  templateVariable: link.metadata.templateVariable,
                  actionName: link.text,
                  actionUrl: link.metadata.actionUrl
              });
          });
          var reqLinkStructures = [];
          var reqLinkMetadata = '';
          angular.forEach($scope.links.requisition, function (requisitionLink) {
              allLinks.push(requisitionLink);
              reqLinkMetadata = requisitionLink.metadata;
              if (reqLinkMetadata) {
                  reqLinkStructures.push({
                      'jobEId': reqLinkMetadata.jobEId,
                      'jobTemplateVariable': reqLinkMetadata.templateVariable,
                      'jobTitle': reqLinkMetadata.jobTitle,
                      'requisitionId': reqLinkMetadata.requisitionId
                  });
              }
          });
          if (reqLinkStructures && reqLinkStructures.length > 0) {
              metadata.reqStructures = reqLinkStructures;
          }
          angular.forEach($scope.links.talentpool, function (talentpoolLink) {
              allLinks.push(talentpoolLink);
              metadata.tpw = angular.extend({}, talentpoolLink.metadata);
              metadata.tpw.captchaEnabled = $scope.captchaEnabled;
              metadata.tpw.captchaDisabledDate = null;
              metadata.tpw.captchaDisabledDuration = 0;
              metadata.tpw.captchaScheduled = null;
              metadata.tpw.scheduledCaptchaDisabledDate = null;
              metadata.tpw.scheduledCaptchaHour = null;
              metadata.tpw.scheduledCaptchaMinutes = null;
              metadata.tpw.scheduledCaptchaTimeZone = null;
              if (!$scope.captchaEnabled) {
                  metadata.tpw.captchaDisabledDuration = $scope.numberOfHours;
                  if ($scope.disableCaptchaOption) {
                      metadata.tpw.captchaScheduled = false;
                  } else {
                      metadata.tpw.captchaScheduled = true;
                      if (angular.isUndefined($scope.captchaDate) || $scope.captchaDate === '' || angular.isUndefined($scope.captchaTime) || angular.isUndefined($scope.captchaTime.h) || angular.isUndefined($scope.captchaTime.m) || angular.isUndefined($scope.timeZoneSelected.openSysId)) {
                          $scope.captchaScheduleError = true;
                          return;
                      }
                      metadata.tpw.scheduledCaptchaDisabledDate = $scope.captchaDate;
                      metadata.tpw.scheduledCaptchaHour = $scope.captchaTime.h;
                      metadata.tpw.scheduledCaptchaMinutes = $scope.captchaTime.m;
                      metadata.tpw.scheduledCaptchaTimeZone = $scope.timeZoneSelected.openSysId;
                  }
              }
              metadata.tpwTemplateVariable = talentpoolLink.metadata.templateVariable;
          });
          allLinks = allLinks.concat($scope.links.templates);
          return {'allLinks': allLinks, 'metadata': metadata, 'type': 'WEBSITE'};
        };

        $scope.saveContent = function (ifPreview) {
            $scope.$emit('syncEditorContent');
            $scope.captchaScheduleError = false;
            if (!$scope.savingContent) {
                var htmlMessage = $scope.content.htmlMessage;
                $scope.savingContent = true;

                var startCutting = htmlMessage.indexOf('<title>');
                var stopCutting = htmlMessage.indexOf('</title>') + '</title>'.length;

                if (startCutting > -1 && stopCutting > -1) {
                    htmlMessage = htmlMessage.substring(0, startCutting) + htmlMessage.substring(stopCutting, htmlMessage.length);
                }

                var linksMetaData = $scope.buildAllLinks();
                if ($scope.captchaScheduleError) {
                    $scope.savingContent = false;
                    return;
                }
                htmlMessage = TinyMceMessageToContent(htmlMessage, linksMetaData.allLinks);

                var matches = [];
                htmlMessage.replace(/\[(.*?)\]/g, function (g0, g1) {
                    matches.push(g1);
                }); // Pushes the strings between the square brackets to matches array

                for (var i = 0; i < matches.length; i++) {
                    var test = $($('<div>').html(matches[i])).text();
                    if (matches[i] !== test) {
                        htmlMessage = htmlMessage.split(matches[i]).join(test); //Replace the HTML text if has encoded characters.
                    }
                }

                var args = {};
                if ($scope.webpageId) {
                    angular.extend(args, {
                        id: $scope.webpageId
                    });
                }
                args.metaData = JSON.stringify(linksMetaData.metadata);

                args.htmlMessage = htmlMessage;
                if (!!ifPreview) {
                    $scope.savingContent = false;
                    campaignService.getPreviewMessage(args, function (results) {
                        modalService.showDummyiframe(results);
                    });
                    return;
                }

                campaignService.saveEmailTemplate(args, function (result) {
                    $scope.saveError = false;
                    var messageToPost = '';
                    var antisamyError = false;
                    if (result.message === 'Validation errors' && result.bean.message.indexOf('Content is too long.') >= 0) {
                        messageToPost = 'You exceeded the total file size (60K bytes) for Web Campaigns.  Please edit your characters and/or code and save again.';
                    } else if (result.status === 'ok') {
                        messageToPost = i18n['JV_CAMPAIGNDETAILS_WEB_PAGE_CONTENT_SAVED'];
                    } else if ($scope.newWebCampaignValidationEnabled && result.error === 400 && result.message === 'Antisamy error' && result.msgError.length > 0) {
                        antisamyError = true;
                        $scope.saveError = true;
                        var errorText = '';
                        for (var i = 0; i < result.msgError.length; i++) {
                            errorText += result.msgError[i] + '\n';
                        }
                        $scope.saveErrorMessage = errorText;
                    }
                    $scope.savingContent = false;
                    if (!antisamyError) {
                        NBar.PostMessage(messageToPost, 'InformationBar');
                        campaignService.getEmailContents();
                    }
                });
            }
        };

        $scope.$on('emailTemplateSaved', function (event, results) {
            if (angular.isNumber(results.bean)) {
                $scope.campaign.webpageUrl = results.webpageUrl;
                $scope.webpageId = results.bean;
            }
        });

        //This method returns the formatted time in am/pm. E.g $scope.captchaTime = {h: 22, m: 30} will return '10:30 PM'
        var setDisplayTime = function () {
            var actualHour, displayHour;
            actualHour = displayHour = $scope.captchaTime.h;
            if (actualHour === 0) {
                displayHour = 12;
            } else if (actualHour > 12) {
                displayHour = actualHour - 12;
            }
            $scope.displayTime = displayHour + ':' + ($scope.captchaTime.m < 10 ? '0' + $scope.captchaTime.m : $scope.captchaTime.m) + (actualHour > 11 ? ' PM' : ' AM');
        };

        $scope.$on('emailContentsReceived', function (event, results) {
            $scope.timeZoneSelected = null;
            $scope.savingContent = false;
            if (results && results.captchaDisableDurations && results.captchaDisableDurations.length > 0) {
                $scope.captchaHours = results.captchaDisableDurations;
                $scope.numberOfHours = $scope.captchaHours[0];
            }
            if (results.resultList && results.resultList.length > 0) {
                var metaData = JSON.parse(results.resultList[0].metaData);
                angular.forEach(['description', 'webpageTitle', 'keywords', 'googleAnalyticsPropertyId', 'ogImage', 'tpw'], function (item) {
                    $scope.metadata[item] = metaData[item];
                });
                if ($scope.metadata['tpw']) {
                    var tpwMetaData = $scope.metadata['tpw'];
                    $scope.captchaEnabled = tpwMetaData['captchaEnabled'];
                    if (tpwMetaData['showCaptchaDisabled']) {
                        $scope.captchaEnabled = false;
                    }
                    if (tpwMetaData.captchaDisabledDuration) {
                        $scope.numberOfHours = tpwMetaData.captchaDisabledDuration;
                    }
                    if (tpwMetaData['captchaScheduled']) {
                        $scope.disableCaptchaOption = false;
                        $scope.timeZoneSelected = campaignService.getSelectedTimeZone($scope.allTimezones, tpwMetaData.scheduledCaptchaTimeZone);
                        $scope.datePickerOptions.minDate = campaignService.getTodayDateUserTimezone($scope.timeZoneSelected);
                        if (tpwMetaData.scheduledCaptchaDisabledDate) {
                            $scope.captchaDate = tpwMetaData.scheduledCaptchaDisabledDate;
                        }
                        if (angular.isDefined(tpwMetaData.scheduledCaptchaHour) && angular.isDefined(tpwMetaData.scheduledCaptchaMinutes)) {
                            $scope.captchaTime = {
                                'h': tpwMetaData.scheduledCaptchaHour,
                                'm': tpwMetaData.scheduledCaptchaMinutes
                            };
                            setDisplayTime();
                        }
                    } else {
                        $scope.disableCaptchaOption = true;
                        $scope.timeZoneSelected = campaignService.getSelectedTimeZone($scope.allTimezones, results.userTimeZone);

                    }

                    if (!$scope.captchaEnabled) {
                        $scope.remainingMinutesForDisabledCaptcha = $scope.metadata['tpw']['remainingMinutesForDisabledCaptcha'];
                    }
                }
                var htmlMessage = results.resultList[0].htmlMessage;
                var allLinks = [];
                $scope.links.talentpool = [];
                $scope.links.custom = [];
                $scope.links.requisition = [];
                $scope.links.reqIds = [];
                angular.forEach(metaData.actions, function (linkMetaData) {
                    $scope.links.custom.push(Draggable(linkMetaData.actionName, linkMetaData.templateVariable, draggableTemplate, {
                        actionName: linkMetaData.actionName,
                        actionUrl: linkMetaData.actionUrl
                    }));
                });
                angular.forEach(metaData.reqStructures, function (reqStructure) {
                    if (reqStructure && reqStructure.jobEId && reqStructure.jobTemplateVariable) {
                        var reqTitleText = campaignService.getReqTitleText(reqStructure.jobTitle, reqStructure.requisitionId);
                        $scope.links.requisition.push(Draggable(reqTitleText, reqStructure.jobTemplateVariable, draggableTemplate, {
                            jobEId: reqStructure.jobEId,
                            requisitionId: reqStructure.requisitionId
                        }));
                        $scope.links.reqIds.push(reqStructure.jobEId);
                    }
                });
                if (angular.isString(metaData.tpwTemplateVariable)) {
                    var juaMetadata = angular.copy(metaData.tpw) || {};
                    $scope.links.talentpool.push(Draggable('Join Us App', '[Join-Us-App]', joinUsDraggableTemplate, juaMetadata));
                    if (results.campaignName) {
                        $scope.links.talentpool[0].metadata.campaignName = results.campaignName;
                    }
                    if (angular.isDefined(juaMetadata.campaign)) {
                        campaignService.getDifferentCampaignDetails({
                            ceid: juaMetadata.campaign
                        }, function (result) {
                            if (result.data && result.data.bean) {
                                juaMetadata.campaignObj = result.data.bean;
                            }
                        });
                    }
                }
                allLinks = allLinks
                    .concat($scope.links.custom)
                    .concat($scope.links.requisition)
                    .concat($scope.links.talentpool)
                    .concat($scope.links.templates);
                htmlMessage = ContentToTinyMceMessage(htmlMessage, allLinks);

                $scope.content.htmlMessage = htmlMessage;
                $scope.webpageId = results.resultList[0].id;
            } else {
                $scope.timeZoneSelected = campaignService.getSelectedTimeZone($scope.allTimezones, results.userTimeZone);
            }
            $scope.captchaDisplayMode = false;
        });

        $scope.selectLayout = function () {
            var deferredService = $q.defer();
            deferredService.promise.then(function (layoutNumber) {
                var cssData =  '<link type="text/css" rel="stylesheet" href="/__assets__/styles/source/campaigns/jv.campaign.public.css">';
                if (layoutNumber === 1) {
                    $scope.content.htmlMessage = '<br />';
                } else if (layoutNumber === 2) {
                    $scope.content.htmlMessage = $interpolate($templateCache.get('oneColumnLayout'))({
                        css: cssData
                    });
                } else if (layoutNumber === 3) {
                    $scope.content.htmlMessage = $interpolate($templateCache.get('twoColumnLayout'))({
                        css: cssData,
                        joinUsApp: joinUsDraggableTemplate('[Join-Us-App]')
                    });
                    if (angular.isUndefined($scope.links.talentpool[0])) {
                        $scope.addJoinUsApp();
                    }

                } else if (layoutNumber === 4) {
                    $scope.content.htmlMessage = $interpolate($templateCache.get('twoColumnRowLayout'))({
                        css: cssData,
                        joinUsApp: joinUsDraggableTemplate('[Join-Us-App]')
                    });

                    if (angular.isUndefined($scope.links.talentpool[0])) {
                        $scope.addJoinUsApp();
                    } else {
                        $scope.links.talentpool[0].metadata.fluidWidth = true;
                    }
                }
            });
            modalService.getWebLayout(deferredService);
        };

        $scope.cancel = function () {
            $window.history.back();
        };

        $scope.$watch('captchaEnabled', function () {
            if ($scope.captchaEnabled) {
                $scope.remainingMinutesForDisabledCaptcha = 240;
            }
        });

        campaignService.getTimeZone({}, function (results) {
            if (results && results.resultList && results.resultList.length > 0) {
                $scope.allTimezones = results.resultList;
                campaignService.getEmailContents();
            }
        });

        $scope.savingContent = true;
        campaignService.getDetails();
        tabInfoService();
    }
]);

appCtrlModule.controller('CampaignSummaryListCtrl', ['$scope', 'campaignService', 'tabInfoService', 'numberFilter',
    function ($scope, campaignService, tabInfoService, numberFilter) {
        $scope.filterObject = {};
        campaignService.getDetails();
        campaignService.getSummary();
        tabInfoService();

        $scope.getStarted = angular.extend({}, {
            explode: true,
            firstLoad: true
        });

        var getTodayDateUserTimezone = function () {
            var userTimeZone = window._jvselfUser.locale.timezone;
            var todayDate = new Date(moment.tz(new Date(), userTimeZone).format('MM/DD/YYYY'));
            return todayDate;
        };

        var today = getTodayDateUserTimezone();

        var initialSettings = {
            fromDate: today.getTime() - (86400000 * 30),
            toDate: today.getTime()
        };


        $scope.resetFilterObject = function () {
            $scope.filterObject.fromDate = initialSettings.fromDate;
            $scope.filterObject.toDate = initialSettings.toDate;
        };

        $scope.resetFilterObject();

        $scope.$watch('filterObject', function (val) {
            if (angular.isDefined(val) && isFinite(val.toDate) && isFinite(val.fromDate)) {
                var args = angular.extend({},
                    (val.fromDate ? {
                        fromDate: val.fromDate
                    } : {
                        fromDate: initialSettings.fromDate
                    }),
                    (val.toDate ? {
                        toDate: val.toDate
                    } : {
                        toDate: initialSettings.toDate
                    }),
                    (val.currentPage ? {
                        page: val.currentPage
                    } : undefined));
                campaignService.getMessages(args);
            }
        }, true);

        $scope.$on('campaignSummaryResults', function (ev, results) {
            var resultExists;
            if (angular.isDefined(results) && angular.isDefined(results.campaignAnalytics) && results.campaignAnalytics != null) {
                $scope.analytics = results.campaignAnalytics;
                $scope.atsEnabled = results.atsEnabled;
                $scope.analytics.clickthroughRates = '' + (numberFilter(results.campaignAnalytics.totalClicks * 100 / results.campaignAnalytics.views, 2) || '0.0') + '%';
                resultExists = (results.campaignAnalytics.views > 0);
                $scope.getStarted.firstLoad = (resultExists ? false : $scope.getStarted.firstLoad);
                $scope.getStarted.explode = (resultExists ? false : $scope.getStarted.explode);
            }
        });

        $scope.results = {
            list: []
        };
    }
]);

//annie
appCtrlModule.controller('SocialSummaryCtrl', ['$scope', 'campaignService', 'tabInfoService', 'numberFilter', '$location', '$routeParams', 'CampaignsReauthorizeFactory', 'CampaignsTwitterFactory', '$q', 'modalService',
    function ($scope, campaignService, tabInfoService, numberFilter, $location, $routeParams, CampaignsFBFactory, CampaignsTwitterFactory, $q, modalService) {
        var FACEBOOK = 'FACEBOOK',
            TWITTER = 'TWITTER';
        $scope.filterObject = {};
        $scope.getStarted = {
            explode: false,
            firstLoad: true
        };
        campaignService.getDetails();
        campaignService.getSummary();
        tabInfoService();
        $scope.results = {
            list: []
        };

        $scope.$watch('filterObject', function (val) {
            if (angular.isDefined(val) && isFinite(val.toDate) && isFinite(val.fromDate)) {
                var args = angular.extend({},
                    (val.fromDate ? {
                        fromDate: val.fromDate
                    } : {
                        fromDate: initialSettings.fromDate
                    }),
                    (val.toDate ? {
                        toDate: val.toDate
                    } : {
                        toDate: initialSettings.toDate
                    }),
                    (val.currentPage ? {
                        page: val.currentPage
                    } : undefined));
                campaignService.getMessages(args);
            }
        }, true);

        $scope.improperDiv = false;
        $scope.$on('campaignSummaryResults', function (ev, results) {
            var resultExists;
            $scope.analytics = results.campaignAnalytics;
            $scope.improperDiv = results.campaignAnalytics.messagesWithLinks === 0 || results.campaignAnalytics.totalClicks === 0;
            if (results && results.campaignAnalytics) {
                resultExists = (results.campaignAnalytics.totalMessages > 0);
                $scope.getStarted.firstLoad = (resultExists ? false : $scope.getStarted.firstLoad);
                $scope.getStarted.explode = (resultExists ? false : $scope.getStarted.explode);
            }
        });

        //show only how to get started sections if there are no results
        $scope.$on('messages', function (ev, results) {
            var resultExists = !(results.analyticsByMessage.length === 0);
            $scope.getStarted.firstLoad = (resultExists ? false : $scope.getStarted.firstLoad);
            $scope.getStarted.explode = (resultExists ? false : $scope.getStarted.explode);
        });

        $scope.addMessage = function () {
            $location.path('campaign/social/editMessage/' + $routeParams.ceid);
        };

        $scope.addAccount = function () {
            $location.path('campaign/social/accounts/' + $routeParams.ceid);
        };

        $scope.reauthorize = function (network) {
            var onSuccessfulReauthorize = function () {
                campaignService.republishError({
                    ceid: $routeParams.ceid,
                    errorEId: network.errorEId
                }, function (results) {
                    campaignService.getDetails();
                });
            };

            if (network.network === FACEBOOK) {
                CampaignsFBFactory(network.errorEId, onSuccessfulReauthorize);
            } else if (network.network === TWITTER) {
                CampaignsTwitterFactory($routeParams.ceid, onSuccessfulReauthorize);
            }
        };
    }
]);

//annie accounts
appCtrlModule.controller('SocialAccountsCtrl', ['$scope', '$q', 'campaignService', 'tabInfoService', 'CampaignsFBFactory', 'CampaignsTwitterFactory', 'modalService', '$routeParams',
    function ($scope, $q, campaignService, tabInfoService, CampaignsFBFactory, CampaignsTwitterFactory, modalService, $routeParams) {
        var ACTIVE = 'ACTIVE',
            INACTIVE = 'INACTIVE',
            FACEBOOK = 'FACEBOOK',
            TWITTER = 'TWITTER';


        var sortFunction = function (account1, account2) {
            return account1.name > account2.name;
        };

        function reloadAccounts(accounts) {
            $scope.activeAccounts = [];
            $scope.inactiveAccounts = [];

            angular.forEach(accounts, function (account) {
                if (account.status === ACTIVE) {
                    $scope.activeAccounts.push(account);
                } else if (account.status === INACTIVE) {
                    $scope.inactiveAccounts.push(account);
                }
            });

            $scope.activeAccounts.sort(sortFunction);
            $scope.inactiveAccounts.sort(sortFunction);
        }

        campaignService.getDetails();
        campaignService.getSummary();
        campaignService.getAccounts({}, function (data) {
            reloadAccounts(data.resultList);
        });
        tabInfoService();

        $scope.activeAccounts = [];
        $scope.inactiveAccounts = [];

        $scope.editStatus = function (account, makeActive) {
            var index,
                fromArrayName, toArrayName;
            if (makeActive) {
                fromArrayName = 'inactiveAccounts';
                toArrayName = 'activeAccounts';
            } else {
                fromArrayName = 'activeAccounts';
                toArrayName = 'inactiveAccounts';
            }

            index = $scope[fromArrayName].indexOf(account);
            $scope[toArrayName].push($scope[fromArrayName].splice(index, 1)[0]);
        };

        var _savedActiveAccounts, _savedInactiveAccounts;

        $scope.editMode = function () {
            $scope.editAccounts = !$scope.editAccounts;
            _savedActiveAccounts = angular.copy($scope.activeAccounts);
            _savedInactiveAccounts = angular.copy($scope.inactiveAccounts);
        };

        $scope.returnToView = function (doSave) {
            $scope.editAccounts = !$scope.editAccounts;
            if (!doSave) {
                $scope.activeAccounts = _savedActiveAccounts;
                $scope.inactiveAccounts = _savedInactiveAccounts;
            } else {
                var accountsToChange = [];
                angular.forEach($scope.activeAccounts, function (active) {
                    if (active.status === INACTIVE) {
                        active.status = ACTIVE;
                        accountsToChange.push(active);
                    }
                });
                angular.forEach($scope.inactiveAccounts, function (inactive) {
                    if (inactive.status === ACTIVE) {
                        inactive.status = INACTIVE;
                        accountsToChange.push(inactive);
                    }
                });
                if (accountsToChange.length > 0) {
                    campaignService.saveAccounts({
                        accounts: accountsToChange
                    }, function (data) {
                        reloadAccounts(data.resultList);
                    });
                }
            }
        };
        $scope.availablePages = [];

        var openAccountsWindow = function () {
            // openModal
            var deferredObj = $q.defer();
            deferredObj.promise.then(function (data) {
                campaignService.saveAccounts({
                    accounts: data
                }, function (fullList) {
                    reloadAccounts(fullList.resultList);
                });
            });
            modalService.selectFBAccount(angular.copy($scope.availablePages), deferredObj);

            return true;
        };

        $scope.FBConnect = function () {
            var successCallback = function (data) {
                $scope.availablePages = data.resultList;
                openAccountsWindow();
            };
            CampaignsFBFactory(successCallback);
        };

        $scope.TwitterConnect = function () {
            var successCallback = function () {

                campaignService.getAccounts({}, function (data) {
                    reloadAccounts(data.resultList);
                });
            };

            CampaignsTwitterFactory($routeParams.ceid, successCallback);
        };
    }
]);

appCtrlModule.controller('BaseCtrl', ['$scope', 'campaignService', 'tabInfoService', 'campaignStatusPrettyMap', 'campaignTypePrettyMap', 'constantService', '3SecondNotificationBar', 'modalService', '$q', '$location', 'i18n',
    function ($scope, campaignService, tabInfoService, campaignStatusPrettyMap, campaignTypePrettyMap, constantService, NBar, modalService, $q, $location, i18n) {
        //VA: needed for transforming dates to the user timezone format.
        $scope.getMilliseconds = function (dateVal) {
            if (dateVal) {
                var d = new Date(dateVal);
                return d.getTime();
            }
        };

        // Available to all the controllers, in the child scope.
        $scope.campaignDetailBaseUrl = window.jvUrls.source + '/campaign2/campaignDetails.html';

        $scope.header = 'campaign2/campaignHeader.html';
        $scope.campaign = {};
        $scope.$on('campaignDetailsResults', function (event, results) {
            $scope.campaign = results.bean;
            if ($scope.campaign && results.webpageUrl) {
                $scope.campaign.webpageUrl = results.webpageUrl;
            }
        });
        $scope.tabInfo = tabInfoService();

        $scope.fireNotification = function (message) {
            NBar.PostMessage(message, 'ClipboardNotifier');
        };

        $scope.status = campaignStatusPrettyMap;
        $scope.type = campaignTypePrettyMap;

        // Initialize the modal dialog.
        window.JV.initializeModal();
        // Make it as part of the root Controller, so its available to everyone.
        $scope.showPageLoading = function () {
            window.JV.showFullPageLoading();
        };
        $scope.removePageLoading = function () {
            window.JV.removeFullPageLoading();
        };
        // In global scope to very a valid url.
        $scope.validateUrl = function (url) {
            //var regexp = /((ftp|http|https):\/\/)(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
            var regexp = /([\-\w]+\.)+\w{2,3}(\/[%\-\w]+(\.\w{2,})?)*(([\w\-\.\?\\/+@&#;`~=%!]*)(\.\w{2,})?)*\/?/;
            return regexp.test(url);
        };

        $scope.showCloneCampaignModal = function () {
            var deferredObj = $q.defer();
            modalService.cloneCampaign($scope.campaign, deferredObj);
            deferredObj.promise.then(function (id) {
                $location.url('/campaign/webpage/content/' + id);
                NBar.PostMessage(i18n.TN_CAMPAIGN_SAVED, 'InformationBar');
            }, function () {
                NBar.PostMessage(i18n.COMMON_OPERATION_ERROR, 'InformationBar');
            });
        };
    }
]);

appCtrlModule.controller('CampaignSummaryHeaderCtrl', ['$scope',
    function ($scope) {
        $scope.filterObject.currentPage = 0;
        $scope.$on('messages', function (event, results) {
            var itemsPerPage = results.pageCount,
                currentPage = $scope.filterObject.currentPage;
            if (itemsPerPage && results.resultCount) {
                $scope.total = results.resultCount;
                $scope.start = Math.max((currentPage * itemsPerPage) + 1, 1);
                $scope.end = Math.min((currentPage + 1) * itemsPerPage, $scope.total);
            }
        });

        $scope.paginate = function (forward) {
            if (forward) {
                if ($scope.end < $scope.total) {
                    $scope.filterObject.currentPage++;
                }
            } else {
                if ($scope.start > 1) {
                    $scope.filterObject.currentPage--;
                }
            }
        };
    }
]);

appCtrlModule.controller('CampaignSummaryGridCtrl', ['$scope',
    function ($scope) {
        function reloadGridResults(results) {
            var resultExists = !(results.analyticsByDate.length === 0);
            $scope.getStarted.firstLoad = (resultExists ? false : $scope.getStarted.firstLoad);
            $scope.getStarted.explode = (resultExists ? false : $scope.getStarted.explode);
            $scope.results.list = results.analyticsByDate;
            $scope.resultExists = resultExists;
        }
        $scope.numberClass = 'number';
        $scope.$on('messages', function (ev, results) {
            $scope.atsEnabled = results.atsEnabled;
            if ($scope.atsEnabled === false) {
                $scope.numberClass = 'numberAdjust';
            }
            angular.forEach(results.analyticsByDate, function (date) {
                angular.forEach(date.analyticsByAction, function (action) {
                    if (action.linkTitle === '[Requisition-Link]') {
                        action.linkTitle = date.requisitionTitle;
                    } else if (action.linkTitle === '[Join-Us-App]' || action.linkTitle === '[Join Us App]') {
                        action.linkTitle = 'Join Us App';
                    }
                });
            });
            reloadGridResults(results);
        });

        $scope.results.list = [];
    }
]);

appCtrlModule.controller('CampaignSummaryFilterCtrl', ['$scope', 'campaignService', 'openFilter', 'closeFilter',
    function ($scope, campaignService, opener, closer) {
        $scope.openFilter = opener;
        $scope.closeFilter = closer;

        var fromDate = new Date($scope.filterObject.fromDate),
            toDate = new Date($scope.filterObject.toDate);
        $scope.friendlyFromDate = [(fromDate.getMonth() + 1), fromDate.getDate(), fromDate.getFullYear()].join('/');
        $scope.friendlyToDate = [(toDate.getMonth() + 1), toDate.getDate(), toDate.getFullYear()].join('/');

        $scope.$watch('friendlyFromDate', function (val) {
            $scope.filterObject.fromDate = Date.parse(val);

        });

        $scope.$watch('friendlyToDate', function (val) {
            $scope.filterObject.toDate = Date.parse(val);
        });

        $scope.reset = function () {
            $scope.resetFilterObject();
            var fromDate = new Date($scope.filterObject.fromDate),
                toDate = new Date($scope.filterObject.toDate);
            $scope.friendlyFromDate = [(fromDate.getMonth() + 1), fromDate.getDate(), fromDate.getFullYear()].join('/');
            $scope.friendlyToDate = [(toDate.getMonth() + 1), toDate.getDate(), toDate.getFullYear()].join('/');
        };
    }
]);

//annie summary controllers
appCtrlModule.controller('SocialSummaryHeaderCtrl', ['$scope',
    function ($scope) {
        $scope.filterObject.currentPage = 0;
        $scope.$on('messages', function (event, results) {
            var itemsPerPage = results.pageCount,
                currentPage = $scope.filterObject.currentPage;
            if (itemsPerPage && results.resultCount) {
                $scope.total = results.resultCount;
                $scope.start = Math.max((currentPage * itemsPerPage) + 1, 1);
                $scope.end = Math.min((currentPage + 1) * itemsPerPage, $scope.total);
            }
        });

        $scope.paginate = function (forward) {
            if (forward) {
                if ($scope.end < $scope.total) {
                    $scope.filterObject.currentPage++;
                }
            } else {
                if ($scope.start > 1) {
                    $scope.filterObject.currentPage--;
                }
            }
        };
    }
]);

appCtrlModule.controller('SocialSummaryGridCtrl', ['$scope',
    function ($scope) {
        function reloadGridResults(results) {
            if (results && results.analyticsByMessage) {
                $scope.results.list = results.analyticsByMessage;
                $scope.resultExists = true;

                //open the message if there is a network publishing error.
                for (var i = 0; i < $scope.results.list.length; i++) {
                    $scope.results.list[i].explode = false;
                    for (var j = 0; j < $scope.results.list[i].analyticsByNetwork.length; j++) {
                        if ($scope.results.list[i].analyticsByNetwork[j].publishingError) {
                            $scope.results.list[i].explode = true;
                        }
                    }
                }
            }
        }
        $scope.$on('messages', function (ev, results) {
            reloadGridResults(results);
        });
        $scope.results = [];
    }
]);

appCtrlModule.controller('SocialSummaryFilterCtrl', ['$scope', 'campaignService', 'openFilter', 'closeFilter', 'dateFilter', '$filter',
    function ($scope, campaignService, opener, closer, dateFilter, $filter) {
        $scope.openFilter = opener;
        $scope.closeFilter = closer;

        function parseFriendlyFromDateToRealDate(val) {
            return $filter('getTimeInMilliseconds')(val);
        }

        function parseFriendlyToDateToRealDate(val) {
            return $filter('getTimeInMilliseconds')(val) + 86399999;
        }

        function formatRealDateToFriendlyDate(val) {
            val = new Date(val);
            return [(val.getMonth() + 1), val.getDate(), val.getFullYear()].join('/');
        }

        $scope.$watch('friendlyFromDate', function (val) {
            $scope.filterObject.fromDate = (!isNaN(Date.parse(val)) ? parseFriendlyFromDateToRealDate(val) : initialSettings.fromDate);
        });

        $scope.$watch('friendlyToDate', function (val) {
            $scope.filterObject.toDate = (!isNaN(Date.parse(val)) ? parseFriendlyToDateToRealDate(val) : initialSettings.fromDate);
        });

        var getTodayDateUserTimezone = function () {
            var userTimeZone = window._jvselfUser.locale.timezone;
            var todayDate = new Date(moment.tz(new Date(), userTimeZone).format('MM/DD/YYYY'));
            return todayDate;
        };

        var today = getTodayDateUserTimezone();

        var initialSettings = {
            fromDate: today.getTime() - (86400000 * 30),
            toDate: today.getTime()
        };

        initialSettings.friendlyFromDate = formatRealDateToFriendlyDate(initialSettings.fromDate);
        initialSettings.friendlyToDate = formatRealDateToFriendlyDate(initialSettings.toDate);

        $scope.reset = function (init) {
            if (init) {
                $scope.filterObject.fromDate = initialSettings.fromDate;
                $scope.filterObject.toDate = initialSettings.toDate;
            }
            $scope.friendlyFromDate = initialSettings.friendlyFromDate;
            $scope.friendlyToDate = initialSettings.friendlyToDate;
        };

        $scope.reset(true);

    }
]);

angular.module('AppCtrl.campaign.webpage.grid', [])
    .filter('truncate', function () {
        return function (string, stringLen, ellipsis) {
            var add;
            if (!angular.isDefined(ellipsis)) {
                ellipsis = true;
            }
            if (string && string.trim() !== '') {
                add = ellipsis && (string.length > stringLen) ? '...' : '';
            } else {
                add = (ellipsis ? '...' : '');
            }
            return (string || '').substr(0, stringLen || Infinity) + add;
        };
    })
    .filter('accountPrint', function () {
        return function (platform) {
            if (platform === 'FACEBOOK') {
                return 'Facebook Page';
            } else if (platform === 'TWITTER') {
                return 'Twitter Account';
            } else {
                return 'Unrecognized Account';
            }
        };
    });